(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-global-faq"] && !Shopify.designMode) return;
  try {
    const setResourceFaqState = (trigger, expanded) => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const wrapper = trigger.closest('.accordion__wrapper');
    if (!panel || !wrapper) return;

    trigger.classList.toggle('accordion-is-open', expanded);
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    wrapper.classList.toggle('is-open', expanded);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-resource-faq-trigger]');
    if (!trigger) return;

    event.preventDefault();
    const shouldExpand = trigger.getAttribute('aria-expanded') !== 'true';
    const group = trigger.closest('[data-resource-faq-group]');

    if (shouldExpand && group) {
      group.querySelectorAll('[data-resource-faq-trigger][aria-expanded="true"]').forEach((openTrigger) => {
        if (openTrigger !== trigger) setResourceFaqState(openTrigger, false);
      });
    }

    setResourceFaqState(trigger, shouldExpand);
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;

    const panel = event.target.closest('[data-resource-faq-body]');
    if (!panel || panel.getAttribute('aria-hidden') === 'true') return;

    const trigger = document.querySelector(`[data-resource-faq-trigger][aria-controls="${panel.id}"]`);
    if (!trigger) return;

    setResourceFaqState(trigger, false);
    trigger.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-subscription"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kp-product-subscription')) {
    customElements.define('kp-product-subscription', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        this.form = document.getElementById(this.dataset.formId);
        this.quantityInput = this.form?.querySelector('[name="quantity"]') || document.querySelector(`[name="quantity"][form="${this.dataset.formId}"]`);
        this.decreaseButton = this.quantityInput?.closest('[data-quantity-selector]')?.querySelector('[data-decrease-quantity]');
        this.sourceInput = this.querySelector('[data-kp-subscription-source]');
        this.tierPropertyInputs = [...this.querySelectorAll('[data-kp-tier-property]')];
        this.submitPlanInput = this.querySelector('[data-kp-selling-plan-submit]');
        this.subscriptionToggle = this.querySelector('[name="selling-plan-group"][value]:not([value=""])');
        this.plansContainer = this.querySelector('[data-group-toggle]');
        this.intervalInputs = [...this.querySelectorAll('[data-kp-interval-input]')];
        this.tiers = [...this.querySelectorAll('[data-kp-tier-data]')]
          .map((element) => ({
            element,
            threshold: Number.parseInt(element.dataset.kpThreshold || '0', 10),
            groupId: element.dataset.kpGroupId,
          }))
          .filter((tier) => tier.threshold > 0 && tier.groupId)
          .sort((left, right) => left.threshold - right.threshold);
        this.autoRaisedQuantity = false;

        if (this.form && this.sourceInput?.parentElement !== this.form) this.form.appendChild(this.sourceInput);
        this.tierPropertyInputs.forEach((input) => {
          if (this.form && input.parentElement !== this.form) this.form.appendChild(input);
        });
        if (this.form && this.submitPlanInput?.parentElement !== this.form) this.form.appendChild(this.submitPlanInput);

        this.addEventListener('change', (event) => {
          if (event.target.matches('[name="selling-plan-group"]')) this.syncPurchaseType();
          if (event.target.matches('[data-kp-interval-input]')) this.syncTier();
        });

        this.quantityInput?.addEventListener('change', () => this.handleQuantityChange(), true);
        this.quantityInput?.addEventListener('input', () => this.handleQuantityChange(), true);
        this.decreaseButton?.addEventListener('click', (event) => {
          if (!this.isSubscription()) return;
          const quantity = this.getQuantity();
          if (quantity <= 2) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.setQuantity(2, false);
          }
        }, true);

        this.form?.addEventListener('submit', (event) => {
          if (!this.isSubscription() || this.getQuantity() >= 2) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setQuantity(2, true);
          this.quantityInput?.focus({ preventScroll: true });
        }, true);

        this.syncPurchaseType();
      }

      isSubscription() {
        return Boolean(this.querySelector('[name="selling-plan-group"]:checked')?.value);
      }

      getQuantity() {
        const quantity = Number.parseInt(this.quantityInput?.value || '1', 10);
        return Number.isFinite(quantity) ? quantity : 1;
      }

      setQuantity(quantity, dispatchChange) {
        if (!this.quantityInput) return;
        const changed = this.getQuantity() !== quantity;
        this.quantityInput.value = String(quantity);
        if (changed && dispatchChange) {
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      handleQuantityChange() {
        if (this.isSubscription() && this.getQuantity() < 2) {
          this.autoRaisedQuantity = true;
          this.setQuantity(2, false);
        } else if (this.getQuantity() !== 2) {
          this.autoRaisedQuantity = false;
        }
        this.syncTier();
      }

      syncPurchaseType() {
        const subscription = this.isSubscription();
        const purchaseType = subscription ? 'subscription' : 'one-time';
        const purchaseTypeChanged = this.dataset.purchaseType !== purchaseType;
        this.dataset.purchaseType = purchaseType;

        // Appstle's cart interceptor only preserves selling_plan when it finds
        // a checked plan radio inside an .appstle_sub_widget form. Keep the
        // class subscription-only so one-time purchases use the normal path.
        if (this.form) this.form.classList.toggle('appstle_sub_widget', subscription);
        if (this.sourceInput) this.sourceInput.disabled = !subscription;
        this.tierPropertyInputs.forEach((input) => {
          input.disabled = !subscription || !input.value;
        });
        if (this.submitPlanInput) {
          this.submitPlanInput.checked = subscription;
          this.submitPlanInput.disabled = !subscription;
        }
        if (this.quantityInput) this.quantityInput.min = subscription ? '2' : '1';
        if (this.plansContainer) this.plansContainer.classList.toggle('hide', !subscription);
        if (this.plansContainer) this.plansContainer.toggleAttribute('inert', !subscription);
        if (this.plansContainer) this.plansContainer.setAttribute('aria-hidden', String(!subscription));
        if (this.subscriptionToggle) this.subscriptionToggle.setAttribute('aria-expanded', String(subscription));

        if (subscription && this.getQuantity() < 2) {
          this.autoRaisedQuantity = true;
          this.setQuantity(2, true);
        } else if (!subscription && this.autoRaisedQuantity && this.getQuantity() === 2) {
          this.autoRaisedQuantity = false;
          this.setQuantity(1, true);
        }

        this.syncTier(purchaseTypeChanged);
      }

      syncTier(forcePlanChange = false) {
        if (!this.tiers.length || !this.intervalInputs.length) return;

        const quantity = Math.max(2, this.getQuantity());
        let activeTier = this.tiers[0];
        this.tiers.forEach((tier) => {
          if (quantity >= tier.threshold) activeTier = tier;
        });

        const checkedInterval = this.querySelector('[data-kp-interval-input]:checked') || this.intervalInputs[0];
        const checkedIndex = checkedInterval.dataset.kpIntervalIndex || '0';
        let checkedPlanData = null;
        let selectedPlanChanged = false;

        this.tierPropertyInputs.forEach((input) => {
          const tier = this.tiers.find((candidate) => String(candidate.threshold) === input.dataset.kpThreshold);
          const planData = tier?.element.querySelector(`[data-kp-tier-plan][data-kp-interval-index="${checkedIndex}"]`);
          input.value = planData?.dataset.kpPlanId || '';
          input.disabled = !this.isSubscription() || !input.value;
        });

        this.intervalInputs.forEach((input) => {
          const index = input.dataset.kpIntervalIndex || '0';
          const planData = activeTier.element.querySelector(`[data-kp-tier-plan][data-kp-interval-index="${index}"]`);
          if (!planData) return;

          if (input === checkedInterval) {
            checkedPlanData = planData;
            selectedPlanChanged = this.submitPlanInput?.value !== planData.dataset.kpPlanId;
          }

          input.value = planData.dataset.kpPlanId;
          const interval = input.closest('[data-kp-interval]');
          const price = interval?.querySelector('[data-kp-plan-price]');
          const comparePrice = interval?.querySelector('[data-kp-plan-compare-price]');
          if (price) price.textContent = planData.dataset.kpPrice;
          if (comparePrice) comparePrice.textContent = planData.dataset.kpComparePrice;
        });

        if (this.subscriptionToggle) this.subscriptionToggle.value = activeTier.groupId;
        if (this.plansContainer) this.plansContainer.dataset.groupToggle = activeTier.groupId;

        if (checkedPlanData) {
          if (this.submitPlanInput) {
            this.submitPlanInput.value = checkedPlanData.dataset.kpPlanId;
            this.submitPlanInput.checked = this.isSubscription();
            this.submitPlanInput.disabled = !this.isSubscription();
          }
          const price = this.querySelector('[data-kp-subscription-price]');
          const comparePrice = this.querySelector('[data-kp-subscription-compare-price]');
          if (price) price.textContent = checkedPlanData.dataset.kpPrice;
          if (comparePrice) comparePrice.textContent = checkedPlanData.dataset.kpComparePrice;
        }

        const message = this.querySelector('[data-kp-tier-message]');
        if (message) {
          const discount = checkedPlanData?.dataset.kpDiscount || activeTier.element.querySelector('[data-kp-tier-plan]')?.dataset.kpDiscount || '0';
          const activeMessage = this.dataset.tierActiveTemplate.replace('__discount__', discount);
          const nextTier = this.tiers.find((tier) => tier.threshold > quantity);

          message.replaceChildren(document.createTextNode(activeMessage));
          if (nextTier) {
            const nextPlan = nextTier.element.querySelector(`[data-kp-tier-plan][data-kp-interval-index="${checkedIndex}"]`) || nextTier.element.querySelector('[data-kp-tier-plan]');
            const remaining = nextTier.threshold - quantity;
            const nextMessage = this.dataset.tierNextTemplate
              .replace('__count__', String(remaining))
              .replace('__discount__', nextPlan?.dataset.kpDiscount || '0');
            const next = document.createElement('span');
            next.textContent = nextMessage;
            message.append(next);
          }
        }

        if (this.submitPlanInput && (forcePlanChange || selectedPlanChanged)) {
          this.submitPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
